module.exports = __webpack_public_path__ + "img/ic-close-small-light.2a5e36fc.svg";